import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import PropTypes from 'prop-types';

import { StyledProgressContainer } from './style';

export const Progress = ({ ...rest }) => {
    return (
        <StyledProgressContainer {...rest}>
            <CircularProgress />
        </StyledProgressContainer>
    );
};

Progress.propTypes = {
    rest: PropTypes.object,
};
